import { ApiEndPoints, NetworkManager } from "../network";

export class CampServices {
    static getAllCamps = () => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.camps
      });
    };

    static addCamp = (camp) => {
      return NetworkManager.getInstance().appRequest({
        method: "post",
        url: ApiEndPoints.camps,
        data: { ...camp },
      });
    };

    static updateCamp = (camp) => {
      return NetworkManager.getInstance().appRequest({
        method: "put",
        url: ApiEndPoints.camps,
        data: { ...camp },
      });
    };

    static deleteCamp = (id) => {
      return NetworkManager.getInstance().appRequest({
        method: "delete",
        url: ApiEndPoints.camps + "/" + id,
        data: { ...id },
      });
    };   
    
    static getCampReport = (id) => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.camps + "/report/" + id,
        data: { ...id },
      });
    };
    
    static getSecondaryScreeningComplaintsByCamp = (campId) => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.camps + "/listByCamp/" + campId
      });
    };
    
    static getSecondaryScreeningComplaintsByTaluk = (talukId) => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.camps + "/listByTaluk/" + talukId
      });
    };
    
    static getSecondaryScreeningComplaintsByPhc = (phcId) => {
      return NetworkManager.getInstance().appRequest({
        method: "get",
        url: ApiEndPoints.camps + "/listByPhc/" + phcId
      });
    };
}